<script lang="ts">
  import { setContext } from 'svelte'
  import { writable } from 'svelte/store'
  import useFixeeClient from '../../../api/fixee-client'
  import { getApiStatusContext, getContactCompaniesContext, getCurrentTeamContext } from '../../../routes/contexts'

  setContext('contactCompanies', writable([]))

  const currentTeam = getCurrentTeamContext()
  const apiStatus = getApiStatusContext()
  const contactCompanies = getContactCompaniesContext()

  const loadFilters = async (teamId?: string) => {
    if (!teamId) return

    const filters = await useFixeeClient().service('contact').loadFilters({ teamId })
    $contactCompanies = filters.companies
  }

  $: if ($apiStatus === 'authenticated') {
    loadFilters($currentTeam?.id)
  }
</script>

<slot contactCompanies={$contactCompanies} />
